export default __webpack_public_path__ + "static/media/water-crisis-mirror-now.0746e9d7.jpg";